import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {template} from './template';
import css from './index.inline.styl';

export class CreateAnnotationButton extends Component<EmptyObj> {
  get config() {
    return {
      css,
      useShadowDom: true,
      template,
    };
  }
}
export const CreateAnnotationButtonEl = defineAndMakeJsxFactory(`create-annotation-button`, CreateAnnotationButton);
export const CreateAnnotationButtonReact = panel2react(`create-annotation-button`, CreateAnnotationButton);
